/**
 * Created by spepa on 24.10.2022
 */

const AchievementDonor = function (unit) {
    UnitComponent.call(this, unit);
};

if (typeof UnitComponent !== "undefined") {
    AchievementDonor.prototype = Object.create(UnitComponent.prototype);
    AchievementDonor.prototype.constructor = AchievementDonor;
}

AchievementDonor.prototype.handleClick = function () {
    const config = cleverapps.achievements.findDonorConfig(this.unit);
    if (config && cleverapps.achievements.isGathered(config.id)) {
        const data = this.unit.getData();
        if (data.landmarkDonor && data.landmarkDonor.finishHint) {
            cleverapps.centerHint.createTextHint(Messages.get(data.landmarkDonor.finishHint));
            this.unit.squeeze();
            return true;
        }
    }
};

AchievementDonor.CreateCinematic = function (unit) {
    const component = unit.findComponent(AchievementDonor);
    if (!component) {
        return;
    }

    const config = cleverapps.achievements.findDonorConfig(unit);
    if (!config) {
        return;
    }

    const landmarks = Map2dLocation.currentLocation && Map2dLocation.currentLocation.landmarks;

    if (config.feature && unit.stage === 0 && landmarks) {
        const landmark = landmarks.findDonorLandmark(unit);
        if (landmark) {
            return [
                function (f) {
                    new GuideWindow(landmarks.getGuideWindowOptions(landmark));
                    cleverapps.focusManager.onceNoWindowsListener = f;
                },
                function (f) {
                    new DonorProgressWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            ];
        }
    }

    const actions = [
        function (f) {
            cleverapps.achievements.increasePendingProgress(unit);

            if (cleverapps.achievements.canGiveAchievement(config)) {
                if (typeof DonorProgressWindow !== "undefined") {
                    new DonorProgressWindow(cleverapps.achievements.findDonorConfig(unit));
                    cleverapps.focusManager.onceNoWindowsListener = f;
                    return;
                }

                cleverapps.achievements.grant(config.id);
            }

            f();
        }
    ];

    if (!landmarks && typeof AchievementRewardWindow !== "undefined") {
        actions.push((f) => {
            if (cleverapps.achievements.isGathered(config.id)) {
                new AchievementRewardWindow(config);
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        });
    }

    return actions;
};
